import { render, staticRenderFns } from "./VehicleTable.vue?vue&type=template&id=7f16b74c&"
import script from "./VehicleTable.vue?vue&type=script&lang=js&"
export * from "./VehicleTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports